<template>
  <div class="dropDownButtonMain">
    <dropdown :is-icon="false" :class-name="'messageDropDown'" ref="menuDropDown"
              :align="'left'"
    >
      <template slot="btn">
        <a class="menuBtn">
          <img class="dropDownBtn" src="@/assets/images/downarrow.png">
        </a>
      </template>
      <template slot="body">
        <div class="messageDropdownMenu">
          <div class="messageMenuItem" @click="reactMsg">
  
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="M480-480Zm0 400q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q43 0 83 8.5t77 24.5v90q-35-20-75.5-31.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160q133 0 226.5-93.5T800-480q0-32-6.5-62T776-600h86q9 29 13.5 58.5T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm320-600v-80h-80v-80h80v-80h80v80h80v80h-80v80h-80ZM620-520q25 0 42.5-17.5T680-580q0-25-17.5-42.5T620-640q-25 0-42.5 17.5T560-580q0 25 17.5 42.5T620-520Zm-280 0q25 0 42.5-17.5T400-580q0-25-17.5-42.5T340-640q-25 0-42.5 17.5T280-580q0 25 17.5 42.5T340-520Zm263.5 221.5Q659-337 684-400H276q25 63 80.5 101.5T480-260q68 0 123.5-38.5Z"/></svg>
            <span class="menuText">Tepki ekle</span>
          </div>
          <div class="messageMenuItem" @click="replyMsg">
            <svg class="menuIcon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="9 14 4 9 9 4"></polyline>
              <path d="M20 20v-7a4 4 0 0 0-4-4H4"></path>
            </svg>
            <span class="menuText">Mesajı cevapla</span>
          </div>
          <div class="messageMenuItem" @click="forwardMsg">
            <svg class="menuIcon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="15 14 20 9 15 4"></polyline>
              <path d="M4 20v-7a4 4 0 0 1 4-4h12"></path>
            </svg>
            <span class="menuText">Mesajı ilet</span>
          </div>
          <div class="messageMenuItem" @click="editMsg" v-if="canEditMessage">
            <svg class="menuIcon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
            </svg>
            <span class="menuText">Mesajı düzenle</span>
          </div>
          <div class="messageMenuItem" v-if="message.isStarredMessage === undefined" @click="starMsg">
            <svg class="menuIcon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
            </svg>
            <span class="menuText">Mesajı yıldızla</span>
          </div>
          <div class="messageMenuItem" v-else @click="unstarMsg">
            <svg class="menuIcon" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2">
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
            </svg>
            <span class="menuText">Yıldızı kaldır</span>
          </div>
          <div class="messageMenuItem deleteItem" @click="deleteMsg" v-if="message.From === $store.state.session.user.UserID">
            <svg class="menuIcon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="3 6 5 6 21 6"></polyline>
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
            </svg>
            <span class="menuText">Mesajı benden sil</span>
          </div>
          <div class="messageMenuItem deleteItem" @click="permanentDeleteMsg"
               v-if="message.From === $store.state.session.user.UserID"
          >
            <svg class="menuIcon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="15" y1="9" x2="9" y2="15"></line>
              <line x1="9" y1="9" x2="15" y2="15"></line>
            </svg>
            <span class="menuText">Mesajı herkesten sil</span>
          </div>
          <div class="messageMenuItem" @click="openInfoMsg" v-if="message.From === $store.state.session.user.UserID">
            <svg class="menuIcon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="11" x2="12" y2="17"></line>
              <line x1="12" y1="7" x2="12" y2="7" stroke-linecap="round"></line>
            </svg>
            <span class="menuText">Mesaj bilgileri</span>
          </div>
        </div>
      </template>
    </dropdown>
  </div>
</template>

<script lang="ts">
// @ts-ignore
// eslint-disable-next-line
  import {messageMixin} from '@/mixins/messageMixin.js'

export default {
  props: {
    message: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },

  mixins: [messageMixin],

  computed: {
    canEditMessage () {
      // Sadece kendi mesajlarını düzenleyebilir
      if (this.message.From !== this.$store.state.session.user.UserID) {
        return false
      }
      // Sadece text mesajları düzenlenebilir (MessageType === 0)
      if (this.message.MessageType !== 0) {
        return false
      }
      // Mesaj 15 dakikadan eski mi kontrol et
      const messageDate = new Date(this.message.CreateDate)
      const now = new Date()
      const diffMinutes = (now - messageDate) / (1000 * 60)
      return diffMinutes <= 15
    }
  },

  methods: {
    adjustDropdownPosition () {
      // Birden fazla nextTick kullanarak DOM'un tamamen güncellenmesini bekle
      this.$nextTick(() => {
        this.$nextTick(() => {
          const dropdown = this.$el.querySelector('.messageDropDown-bp__body')
          if (dropdown) {
            const rect = dropdown.getBoundingClientRect()
            const windowHeight = window.innerHeight
            
            // Eğer dropdown ekranın alt sınırını aşıyorsa yukarı kaydır
            if (rect.bottom > windowHeight - 20) {
              const overflow = rect.bottom - (windowHeight - 20)
              dropdown.style.transform = `translateY(-${overflow}px)`
            } else {
              dropdown.style.transform = 'translateY(0)'
            }
          }
        })
      })
    },

    reactMsg () {
      this.$refs.menuDropDown.isHidden = true
      this.$emit('open-reactions')
    },
    handleScroll (event) {
      var ddown = document.querySelector('.bp-dropdown__body.messageDropDown-bp__body') 
      if (ddown !== null) {
        ddown.style.display = 'none'
      }
    },
    infoMsg () {
      this.$refs.menuDropDown.isHidden = true
    },
    starMsg () {
      var item = this.$store.state.message.messages.find(x => x.MessageID === this.message.MessageID)
      this.$set(item, 'isStarredMessage', true)
      this.$store.state.message.starredMessages.push(this.message)
      this.starMessage()
    },
    unstarMsg () {
      var item = this.$store.state.message.messages.find(x => x.MessageID === this.message.MessageID)
      this.$set(item, 'isStarredMessage', undefined)
      var ix = this.$store.state.message.starredMessages.findIndex(x => x.MessageID === this.message.MessageID)
      if (ix !== -1) {
        this.$store.state.message.starredMessages.splice(ix, 1)
        this.starMessage()
      }
    },
    replyMsg () {
      this.$refs.menuDropDown.isHidden = true

      this.$store.state.message.ReplyMessage = this.message
      this.$store.state.conversation.activeConversation.newMessage.ReplyMessage = JSON.stringify(this.message)
      this.$store.state.message.isReplyMessageOpen = true
    },
    forwardMsg () {
      this.$refs.menuDropDown.isHidden = true

      let messageToForward = this.message
      this.$store.commit('setMessageToForward', messageToForward)

      this.$store.state.display.modal.viewState = 'forwardMessage'
      this.$modal.show('homepage')
    },

    editMsg () {
      this.$refs.menuDropDown.isHidden = true
      // Düzenleme modunu aktif et ve mesajı store'a kaydet
      this.$store.state.message.editingMessage = this.message
    },

    deleteMsg () {
      this.$refs.menuDropDown.isHidden = true
      this.deleteMessage(this.message)
    },

    permanentDeleteMsg () {
      this.$refs.menuDropDown.isHidden = true
      this.permanentDeleteMessage(this.message)
    },

    openInfoMsg () {
      this.$refs.menuDropDown.isHidden = true
      // Menü kapandıktan sonra tooltip'i aç (click event'inden kaçınmak için)
      setTimeout(() => {
        // Mesaj grup mesajı ise isGroup özelliğini ekle
        const messageToShow = { ...this.message }
        
        // Aktif konuşmanın grup olup olmadığını kontrol et
        const activeConversation = this.$store.state.conversation.activeConversation
        if (activeConversation && (activeConversation.isGroupConversation || activeConversation.GroupID)) {
          messageToShow.isGroup = true
        }
        
        this.$store.state.display.messageInfoModal = {
          isOpen: true,
          message: messageToShow
        }
      }, 100)
    }
  },
  mounted () {
    // Dropdown açıldığında pozisyonu ayarla
    if (this.$refs.menuDropDown) {
      this.$refs.menuDropDown.$watch('isHidden', (newVal) => {
        if (!newVal) {
          // İlk açılışta ve sonraki açılışlarda çalışması için timeout ekle
          setTimeout(() => {
            this.adjustDropdownPosition()
          }, 10)
        }
      })
    }
  },
  created () {
    var container = document.getElementById('messagesMainContainer')
    if (container !== null) {
      container.addEventListener('scroll', this.handleScroll)
    }
  },
  destroyed () {
    var container = document.getElementById('messagesMainContainer')
    if (container !== null) {
      container.removeEventListener('scroll', this.handleScroll)
    }
  }

}

</script>

<style lang="less" scoped>
  .dropDownButtonMain {
    position: absolute;
    right: 5px;
    top: 5px;
    z-index: 20;
  }

  .dropDownBtn {
    width: 10px;
    height: 10px;
    cursor: pointer;
  }
  
  .menuBtn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    border-radius: 6px;
    background-color: transparent;
    transition: all 0.2s ease;
  }

  .messageDropdownMenu {
    padding: 4px;
    background: #FFFFFF;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    min-width: 180px;
    z-index: 999999999;
  }

  .messageMenuItem {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    font-size: 13px;
    cursor: pointer;
    background-color: transparent;
    border-radius: 6px;
    transition: all 0.2s ease;
    color: #333;
  }

  .messageMenuItem:hover {
    background-color: #f5f5f5;
    transform: translateX(2px);
  }

  .messageMenuItem.deleteItem {
    color: #dc3545;
  }

  .messageMenuItem.deleteItem:hover {
    background-color: #fff5f5;
  }

  .menuIcon {
    width: 18px;
    height: 18px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .menuText {
    flex: 1;
    font-weight: 500;
  }

</style>

<style lang="less">

  span.wrapper {
    position: relative;
    display: flex;
    justify-content: flex-start;
    width: 100%;
    height: 100%;

    .messageBalloonMain {
      margin-right: auto;
      margin-left: 20px;
    }

    &.flex-end {
      justify-content: flex-end;

      .messageBalloonMain {
        margin-right: 20px;
        margin-left: 0;
      }
    }
  }

  .messageDropDown-bp__btn {
    border: none !important;
    display: none !important;
    border-radius: 6px !important;
  }
  
  .messageDropDown-bp.bp-dropdown--is-open .messageDropDown-bp__btn {
    display: flex !important;
    background-color: #f5f5f5 !important;
  }

  .messageBalloonMain:hover .messageDropDown-bp__btn {
    display: flex !important;
  }
  .messageBalloonMainReverse:hover .messageDropDown-bp__btn {
    display: flex !important;
  }

  .messageDropDown-bp__body {
    z-index: 9999 !important;
    transition: transform 0.2s ease;
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    padding: 0 !important;
    margin-right: 8px !important;
  }
</style>
